// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  max-width: 1120px;
  margin: 0 auto;
  padding: 8px 0 48px;
}

.home-intro {
  margin-bottom: 22px;
  padding: 20px 4px 8px;
}

.home-eyebrow {
  margin: 0 0 8px;
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.home-intro h1,
.home-section-heading h2 {
  margin: 0;
  color: #183b3b;
}

.home-intro h1 {
  max-width: 620px;
  font-size: clamp(30px, 5vw, 48px);
  line-height: 1.05;
}

.home-intro > p:last-child {
  max-width: 560px;
  margin: 12px 0 0;
  color: #637878;
  font-size: 16px;
  line-height: 1.5;
}

.home-learning-grid {
  display: grid;
  gap: 18px;
}

.home-learning-grid > * {
  width: auto;
  max-width: none;
  margin: 0;
}

.home-explore {
  margin-top: 28px;
  padding: 22px;
  border: 1px solid #d7e4e5;
  border-radius: 14px;
  background: #fff;
}

.home-section-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.home-section-heading h2 {
  font-size: 22px;
}

.home-section-heading > span {
  color: #637878;
  font-size: 13px;
}

.home-explore-links {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.home-explore-links a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #d7e4e5;
  border-radius: 9px;
  padding: 12px 14px;
  color: #183b3b;
  font-weight: 700;
  text-decoration: none;
  transition: border-color 0.15s, background 0.15s, transform 0.15s;
}

.home-explore-links a span {
  color: #0f766e;
  font-size: 12px;
  font-weight: 600;
}

.home-feature-title {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #183b3b !important;
  font-size: inherit !important;
  font-weight: 700 !important;
}

.home-feature-title .home-ai-badge {
  border-radius: 999px;
  padding: 2px 5px;
  background: #e36f4b;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.home-explore-links a:hover {
  border-color: #99d5ca;
  background: #f1fbf8;
  transform: translateY(-1px);
}

@media (min-width: 601px) and (max-width: 1099px) and (orientation: portrait) {
  .home-learning-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .home-intro {
    padding-top: 8px;
  }

  .home-explore {
    padding: 16px;
  }

  .home-section-heading {
    display: block;
  }

  .home-section-heading > span {
    display: block;
    margin-top: 6px;
  }

  .home-explore-links {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iEAAiE;AACnE;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".home-page {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 8px 0 48px;\n}\n\n.home-intro {\n  margin-bottom: 22px;\n  padding: 20px 4px 8px;\n}\n\n.home-eyebrow {\n  margin: 0 0 8px;\n  color: #0f766e;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.home-intro h1,\n.home-section-heading h2 {\n  margin: 0;\n  color: #183b3b;\n}\n\n.home-intro h1 {\n  max-width: 620px;\n  font-size: clamp(30px, 5vw, 48px);\n  line-height: 1.05;\n}\n\n.home-intro > p:last-child {\n  max-width: 560px;\n  margin: 12px 0 0;\n  color: #637878;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.home-learning-grid {\n  display: grid;\n  gap: 18px;\n}\n\n.home-learning-grid > * {\n  width: auto;\n  max-width: none;\n  margin: 0;\n}\n\n.home-explore {\n  margin-top: 28px;\n  padding: 22px;\n  border: 1px solid #d7e4e5;\n  border-radius: 14px;\n  background: #fff;\n}\n\n.home-section-heading {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.home-section-heading h2 {\n  font-size: 22px;\n}\n\n.home-section-heading > span {\n  color: #637878;\n  font-size: 13px;\n}\n\n.home-explore-links {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.home-explore-links a {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border: 1px solid #d7e4e5;\n  border-radius: 9px;\n  padding: 12px 14px;\n  color: #183b3b;\n  font-weight: 700;\n  text-decoration: none;\n  transition: border-color 0.15s, background 0.15s, transform 0.15s;\n}\n\n.home-explore-links a span {\n  color: #0f766e;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.home-feature-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: #183b3b !important;\n  font-size: inherit !important;\n  font-weight: 700 !important;\n}\n\n.home-feature-title .home-ai-badge {\n  border-radius: 999px;\n  padding: 2px 5px;\n  background: #e36f4b;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.home-explore-links a:hover {\n  border-color: #99d5ca;\n  background: #f1fbf8;\n  transform: translateY(-1px);\n}\n\n@media (min-width: 601px) and (max-width: 1099px) and (orientation: portrait) {\n  .home-learning-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .home-intro {\n    padding-top: 8px;\n  }\n\n  .home-explore {\n    padding: 16px;\n  }\n\n  .home-section-heading {\n    display: block;\n  }\n\n  .home-section-heading > span {\n    display: block;\n    margin-top: 6px;\n  }\n\n  .home-explore-links {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
